import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '@isophi/core-legacy';
import {ChildService} from "../../../core/services/child.service";

@Component({
    selector: 'app-language-picker',
    templateUrl: './language-picker.component.html',
    styleUrls: ['./language-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LanguagePickerComponent {
  constructor(public i18n: TranslocoService, public childService: ChildService, public authService: AuthService) {}
}
